module.exports = __webpack_public_path__ + "static/media/izzy.e9c589a8.jpg";